import * as React from 'react'
import { SVGProps, memo } from 'react'

const RestyleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={26}
    height={26}
    viewBox='0 0 26 26'
    fill='none'
    {...props}
  >
    <path
      fill='currentColor'
      fillRule='evenodd'
      d='M4.578.809c-.159.171-.499.846-.756 1.498-.256.653-.56 1.27-.675 1.374-.114.102-.728.396-1.364.65C.443 4.87 0 5.179 0 5.575c0 .419.463.786 1.9 1.504 1.4.7 1.463.772 1.984 2.236.364 1.023.744 1.543 1.165 1.592.585.068 1.001-.468 1.589-2.046.297-.8.578-1.046 2.066-1.815 2.24-1.158 2.201-1.915-.136-2.658-.482-.154-.982-.37-1.11-.482-.13-.112-.505-.77-.834-1.463C5.714.532 5.206.127 4.578.81Zm7.967 1.19c-.574.246-.857 1.44-.505 2.13.085.166.307.416.493.555.32.238.595.257 4.892.332 4.991.086 5.096.103 5.305.855.123.442.126 15.318.003 15.758-.119.427-.203.454-1.947.635-1.992.206-13.204.205-15.203-.002-1.566-.162-1.868-.254-2.021-.615-.053-.123-.137-2.118-.189-4.434-.1-4.544-.191-5.199-.794-5.768-.167-.157-.53-.316-.807-.354-.434-.058-.549-.02-.817.271-.443.48-.571 1.261-.658 4.008-.094 2.928.095 5.736.465 6.94.477 1.555 2.075 2.802 3.928 3.068 1.117.16 15.69.164 16.913.005.525-.07 1.177-.258 1.557-.451.792-.403 2.043-1.575 2.37-2.22.446-.876.506-2.138.455-9.53-.061-8.814-.019-8.59-1.92-10.115-1.359-1.09-1.4-1.097-6.68-1.144-2.647-.024-4.68.009-4.84.077Zm-.413 5.799c-1.388.27-2.97 1.364-3.868 2.678-2.44 3.562-.185 8.5 4.16 9.111 2.964.417 5.977-1.745 6.594-4.732.25-1.21.104-2.233-.495-3.477-1.294-2.685-3.794-4.086-6.39-3.58Zm2.291 3.145c.397.204 1.452 1.25 1.659 1.644.24.459.227 1.78-.022 2.308-.249.527-1.177 1.399-1.743 1.636-.853.358-2.358.138-3.189-.466-.665-.484-.99-1.2-.994-2.183-.004-1.635.603-2.536 1.997-2.962.486-.148 1.987-.133 2.292.023Z'
      clipRule='evenodd'
    />
  </svg>
)

const Memo = memo(RestyleIcon)
export default Memo
